<template>
    <div>
        您好,<span style="color:red">{{ currentUserName }}</span
        >欢迎登陆威瓦后台管理系统
    </div>
</template>

<script>
import { getRequest } from '@/utils/api';
import { getCurrentUserName } from '@/api';
export default {
    name: 'Welcome',
    data() {
        return {
            currentUserName: '',
        };
    },
    async mounted() {
        try {
            const { data, status } = await getCurrentUserName();
            if (status === 200) {
                this.currentUserName = data;
            } else {
                getRequest('/logout');
                this.currentUserName = '游客';
                this.$router.replace({ path: '/' });
            }
        } catch (error) {}
    },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/welcome/index.vue